export class PlannedMaintenanceDeviceDto {
    plannedMaintenanceDeviceId: number;
    deviceModelId: number;
    deviceModelName: string;
    cost: number;
    discount: number;
    plannedMaintenanceId: number;
    agreementId: number;

    count: number;
}